import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckboxStandardModule } from '../../forms/checkbox-standard/checkbox-standard.module';
import { CalendarSingleComponent } from './calendar-single.component';

@NgModule({
  imports: [CommonModule, CheckboxStandardModule],
  declarations: [CalendarSingleComponent],
  exports: [CalendarSingleComponent]
})
export class CalendarSingleModule {}
